import apiClient from './apiClient';

export async function listCombos(params = {}) {
  const { data } = await apiClient.get('/api/combos', { params });
  return data;
}

export async function createCombo(payload) {
  const { data } = await apiClient.post('/api/admin/combo', payload);
  return data;
}

export async function updateCombo(id, payload) {
  const { data } = await apiClient.put(`/api/admin/combo/${id}`, payload);
  return data;
}

export async function deleteCombo(id) {
  const { data } = await apiClient.delete(`/api/admin/combo/${id}`);
  return data;
}
